import * as s from './store';
import {RadioConnected} from 'webmapsjs/dist/reactComponents/Radio';
// import React = require("react");
import * as React from 'react';
import {connect} from "react-redux";
import * as cnt from './constants';

import {setVisibleLayers} from './layers';


class ConnectedCheck extends React.Component<{label: string; callback: (d: boolean) => any, checked: boolean}, null>{

    render() {
        let theId = 'id-' + this.props.label;
        return <div>
            <label htmlFor={theId}>{this.props.label}</label>
            <input type="checkbox" id={theId} checked={this.props.checked} onChange={(d) => {
                this.props.callback(d.target.checked);
                setVisibleLayers();
            }}/>
        </div>
    }
}

export const Metric = connect(
    (state: s.iState) => {
        return {
            title: "Metric",
            items: cnt.valsMetrics,
            inline: false,
            selectedIndex: cnt.valsMetrics.indexOf(state.metric)
        }
    },
    (dispatch) => {
        return {
            callback: (d) => {
                let a: s.iSetMetric = {type: s.SET_METRIC, metric: cnt.valsMetrics[d]};
                dispatch(a);
                setVisibleLayers();
            }
        }
    })(RadioConnected);

export const TimePeriod = connect(
    (state: s.iState) => {
        return {
            title: "Time Period",
            items: cnt.valsTimePeriod,
            inline: false,
            selectedIndex: cnt.valsTimePeriod.indexOf(state.period)
            // selectedIndex: s.valsMetrics.indexOf(state.metric)
        }
    },
    (dispatch) => {
        return {
            callback: (d) => {
                let a: s.iSetPeriod = {type: s.SET_PERIOD, period: cnt.valsTimePeriod[d]};
                dispatch(a);
                setVisibleLayers();
            }
        }
    })(RadioConnected);


export const Interstates = connect(
        (state: s.iState) => {
        return {
            label: "Interstates",
            checked: state.showInterstate
        }
    },
    (dispatch) => {
        return {
            callback: (d) => {
                let a: s.iSetShowRoads = {type: s.SET_SHOW_INTERSTATE, show: d};
                dispatch(a);
            }
        }
    })(ConnectedCheck);

export const OtherRoads = connect(
        (state: s.iState) => {
        return {
            label: "Other Roads",
            checked: state.showOther
        }
    },
    (dispatch) => {
        return {
            callback: (d) => {
                let a: s.iSetShowRoads = {type: s.SET_SHOW_OTHER, show: d};
                dispatch(a);
            }
        }
    })(ConnectedCheck);